import React from "react"
import { Typography, makeStyles } from "@material-ui/core"
import { RichDescription } from ".."

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    marginBottom: theme.spacing(2.5),
  },
  typography: {
    fontSize: 13,
    lineHeight: "20px",
    marginLeft: theme.spacing(0.5),
    wordBreak: "break-all",
  },
}))

const Ref = props => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography variant={"body2"}>{`${props.index}.`}</Typography>
      <Typography variant={"body2"} className={classes.typography}>
        {props.text && <RichDescription copyText={props.text} />}
      </Typography>
      <br />
    </div>
  )
}

export default Ref
